/* ESVAE core runtime: shipping protection sync, delivery estimates,
   cart offers, in-view video playback. No dependencies. */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Cart helpers shared with the wand page (window.evCart)
     ------------------------------------------------------------------ */
  var SECTIONS = ['cart-drawer', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer'];
  function target(id) {
    if (id === 'cart-drawer') return document.querySelector('#CartDrawer');
    return document.getElementById(id) || document.getElementById('shopify-section-' + id);
  }
  function wanted() { return SECTIONS.filter(function (id) { return !!target(id); }).join(','); }
  function inner(html, selector) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var el = doc.querySelector(selector) || doc.querySelector('.shopify-section');
      return el ? el.innerHTML : null;
    } catch (e) { return null; }
  }
  function apply(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var el = target(id);
      if (!el || !sections[id]) return;
      var html = inner(sections[id], id === 'cart-drawer' ? '#CartDrawer' : '#' + id);
      if (html !== null) el.innerHTML = html;
    });
    var overlay = document.querySelector('#CartDrawer-Overlay');
    var drawer = document.querySelector('cart-drawer');
    if (overlay && drawer && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
    var inner_ = document.querySelector('#CartDrawer .drawer__inner');
    var empty = !document.querySelector('#CartDrawer .cart-item');
    if (inner_) inner_.classList.toggle('is-empty', empty);
    if (drawer) drawer.classList.toggle('is-empty', empty);
    document.dispatchEvent(new CustomEvent('ev:cart-rendered'));
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return r.ok ? j : Promise.reject(j); }); });
  }
  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
    else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }

  /* ------------------------------------------------------------------
     Shipping protection: auto-add once there are real items in the cart.
     Opt-out (toggle off / line removed) is remembered until the cart is
     emptied. Ported from the IFW store implementation.
     ------------------------------------------------------------------ */
  var OPT = 'ev_sp_optout';
  var busy = false;
  function spId() { return window.evProtection && window.evProtection.variant ? String(window.evProtection.variant) : ''; }
  function optedOut() { try { return localStorage.getItem(OPT) === '1'; } catch (e) { return false; } }
  function setOptOut(v) { try { v ? localStorage.setItem(OPT, '1') : localStorage.removeItem(OPT); } catch (e) {} }

  function sync() {
    var id = spId();
    if (busy || !id) return Promise.resolve();
    busy = true;
    return fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var sp = items.filter(function (i) { return String(i.variant_id) === id; });
        var others = items.length - sp.length;
        var qty = sp.reduce(function (a, i) { return a + i.quantity; }, 0);
        var secs = wanted();
        if (others === 0) {
          setOptOut(false);
          if (qty > 0) return post('/cart/change.js', { id: sp[0].key, quantity: 0, sections: secs }).then(function (s) { apply(s.sections); });
          return null;
        }
        if (qty === 0) {
          if (optedOut()) return null;
          return post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }], sections: secs }).then(function (s) { apply(s.sections); });
        }
        if (qty > 1) return post('/cart/change.js', { id: sp[0].key, quantity: 1, sections: secs }).then(function (s) { apply(s.sections); });
        return null;
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.id === 'cart-upsell-toggle') setOptOut(!e.target.checked);
  }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('cart-remove-button');
    if (!btn) return;
    var row = btn.closest('.cart-item');
    var input = row && row.querySelector('input[data-quantity-variant-id]');
    if (input && input.getAttribute('data-quantity-variant-id') === spId()) setOptOut(true);
  }, true);

  /* resync after any cart mutation made by the theme or apps */
  var nativeFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(String(url))) {
      var own = /\/cart\/add/.test(String(url)) && selfAdd > 0;
      if (own) selfAdd--;
      p.then(function () { setTimeout(function () { if (!own) sync(); document.dispatchEvent(new CustomEvent('ev:cart-changed')); }, own ? 0 : 350); }).catch(function () {});
    }
    return p;
  };

  /* ------------------------------------------------------------------
     Add-to-cart for custom forms (wand page, cart offers).
     items: [{id, quantity, properties?}]
     ------------------------------------------------------------------ */
  var selfAdd = 0;
  function addItems(items) {
    var id = spId();
    /* the drawer already reflects the cart: skip the extra /cart.js round trip */
    var toggle = document.getElementById('cart-upsell-toggle');
    var hasLines = !!document.querySelector('#CartDrawer .cart-item');
    var needSp = !!id && !optedOut() && !(hasLines && toggle && toggle.checked);
    var list = items.slice();
    if (needSp) list.push({ id: Number(id), quantity: 1 });
    /* the cart lists the newest line first: send in reverse so the first item stays on top */
    list.reverse();
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.add('ev-loading');
    openDrawer();
    selfAdd++;
    return post('/cart/add.js', { items: list, sections: wanted() || 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
      .then(function (res) {
        apply(res.sections);
        return res;
      })
      .finally(function () {
        var d = document.querySelector('cart-drawer');
        if (d) d.classList.remove('ev-loading');
      });
  }
  /* video posters load only when the video is near the screen */
  function lazyPosters() {
    var vs = [].slice.call(document.querySelectorAll('video[data-poster]'));
    if (!vs.length) return;
    function set(v) {
      var u = v.dataset.poster; if (!u) return;
      v.style.backgroundImage = 'url("' + u + '")'; v.style.backgroundSize = 'cover'; v.style.backgroundPosition = 'center';
      v.poster = u; v.removeAttribute('data-poster');
    }
    if (!('IntersectionObserver' in window)) { vs.forEach(set); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { set(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '2000px 800px' });
    vs.forEach(function (v) { io.observe(v); });
    window.addEventListener('load', function () { setTimeout(function () { [].forEach.call(document.querySelectorAll('.ev-wg video[data-poster]'), set); }, 2500); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lazyPosters); else lazyPosters();

  window.evCart = { add: addItems, apply: apply, open: openDrawer, sync: sync };

  /* cart offer buttons: <button data-ev-offer="variantId"> */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-ev-offer]');
    if (!b) return;
    e.preventDefault();
    b.setAttribute('aria-busy', 'true');
    addItems([{ id: Number(b.getAttribute('data-ev-offer')), quantity: 1 }]).catch(function () {}).then(function () { b.removeAttribute('aria-busy'); });
  });

  /* ------------------------------------------------------------------
     Delivery estimate: business-day math + cutoff countdown.
     <div data-ev-delivery data-cutoff="14" data-process="1" data-min="3" data-max="7">
     ------------------------------------------------------------------ */
  function addBiz(d, n) {
    var x = new Date(d);
    while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
    return x;
  }
  function fmt(d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
  function fmtShort(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
  function initDelivery(root) {
    var cutoff = Number(root.dataset.cutoff || 14), proc = Number(root.dataset.process || 1);
    var min = Number(root.dataset.min || 7), max = Number(root.dataset.max || 11);
    var set = function (k, v) { var el = root.querySelector('[data-ev="' + k + '"]'); if (el) el.textContent = v; };
    function tick() {
      var now = new Date(), w = now.getDay();
      var bizToday = w !== 0 && w !== 6;
      var cut = new Date(now); cut.setHours(cutoff, 0, 0, 0);
      var before = bizToday && now < cut;
      /* dispatch window: first possible day .. first + processing days */
      var first = before ? new Date(now) : addBiz(now, 1);
      var last = addBiz(first, proc);
      var a = addBiz(first, min), b = addBiz(last, max);
      set('ship', fmt(last));
      set('ship-range', proc > 0 ? fmtShort(first) + ' - ' + fmtShort(last) : fmtShort(first));
      set('arrive', fmtShort(a) + ' - ' + fmtShort(b));
      var next = before ? cut : (function () { var c = new Date(first); c.setHours(cutoff, 0, 0, 0); return c; })();
      var ms = Math.max(0, next - now), h = Math.floor(ms / 3.6e6), m = Math.floor(ms % 3.6e6 / 6e4), s = Math.floor(ms % 6e4 / 1e3);
      set('timer', (h ? h + 'h ' : '') + m + 'm' + (h ? '' : ' ' + s + 's'));
    }
    tick();
    setInterval(tick, 1000);
  }

  /* carrier by visitor country (IP via Shopify browsing context), cached per session */
  /* [logo file (null = text chip), display name, show name next to logo] */
  var CARRIERS = {
    US: ['usps.svg', 'USPS', true], CA: ['canadapost.svg', 'Canada Post'], GB: ['royalmail.svg', 'Royal Mail'], IE: ['anpost.svg', 'An Post'],
    DE: ['dhl.svg', 'DHL'], CZ: ['dhl.svg', 'DHL'], MX: ['dhl.svg', 'DHL'], IL: ['dhl.svg', 'DHL'],
    AT: ['post-at.svg', 'Österreichische Post', true], CH: ['swisspost.svg', 'Swiss Post'], FR: ['laposte.svg', 'La Poste'],
    NL: ['postnl.svg', 'PostNL'], BE: ['bpost.svg', 'bpost'], LU: ['post-lu.svg', 'POST Luxembourg', true],
    IT: ['poste.svg', 'Poste Italiane'], ES: ['correos.svg', 'Correos', true], PL: ['inpost.svg', 'InPost'],
    SE: ['postnord.svg', 'PostNord'], DK: ['postnord.svg', 'PostNord'], FI: ['posti.svg', 'Posti'],
    AU: ['auspost.svg', 'Australia Post'], NZ: ['nzpost.png', 'NZ Post'],
    PT: [null, 'CTT', true], NO: [null, 'Posten', true], JP: [null, 'Japan Post', true], SG: [null, 'SingPost', true],
    AE: [null, 'Aramex', true], SA: [null, 'Aramex', true]
  };
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function applyCarrier(code) {
    var c = CARRIERS[code];
    document.querySelectorAll('[data-ev-delivery]').forEach(function (root) {
      var chip = root.querySelector('[data-ev-carrier]');
      if (!chip) return;
      var lead = root.querySelector('[data-ev-carrier-lead]');
      if (lead && !lead.dataset.generic) lead.dataset.generic = lead.innerHTML;
      var forced = (root.dataset.carrier || 'auto').toLowerCase();
      var known = !!c || (forced !== 'auto' && forced !== '');
      /* unknown country: globe + "Free worldwide tracked shipping", no chip */
      chip.hidden = !known;
      if (lead) lead.innerHTML = known ? '<strong>Free</strong> tracked shipping with' : lead.dataset.generic;
      if (!known) return;
      var base = root.dataset.assets || '';
      var file = c ? c[0] : null, name = c ? c[1] : '', withName = c ? (c[2] || !file) : true;
      if (forced !== 'auto' && forced !== '') { file = null; name = root.dataset.carrier; withName = true; }
      chip.classList.toggle('ev-carrier--logo', !!file);
      chip.setAttribute('data-c', file ? file.replace(/\..+$/, '') : 'text');
      chip.innerHTML = (file ? '<img src="' + base + 'ev-carrier-' + file + '" alt="' + esc(name) + '" loading="lazy" width="80" height="24">' : '') + (withName ? '<span class="ev-carrier__name">' + esc(name) + '</span>' : '');
    });
  }
  function detectCountry() {
    var cached; try { cached = sessionStorage.getItem('ev_cc'); } catch (e) {}
    var fallback = (document.querySelector('[data-ev-delivery]') || {}).dataset;
    fallback = fallback && fallback.country;
    if (cached) return applyCarrier(cached);
    applyCarrier(fallback);
    fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var cc = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        if (!cc) return;
        cc = String(cc).toUpperCase();
        try { sessionStorage.setItem('ev_cc', cc); } catch (e) {}
        applyCarrier(cc);
      }).catch(function () {});
  }

  /* ------------------------------------------------------------------
     Videos: play muted loops only while visible (saves CPU + data)
     ------------------------------------------------------------------ */
  function initVideos(scope) {
    var vids = (scope || document).querySelectorAll('video[data-ev-autoplay]');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { v.play && v.play().catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          if (v.preload === 'none') v.preload = 'auto';
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else v.pause();
      });
    }, { rootMargin: '120px 0px', threshold: .15 });
    vids.forEach(function (v) { v.muted = true; v.playsInline = true; io.observe(v); });
  }

  /* casual copy protection: no context menu, image drag or devtools shortcuts
     (skipped inside the theme editor) */
  if (!(window.Shopify && window.Shopify.designMode)) {
    document.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    var editable = function (el) { return el && el.closest && el.closest('input, textarea, select, [contenteditable="true"]'); };
    ['copy', 'cut'].forEach(function (t) { document.addEventListener(t, function (e) { if (!editable(e.target)) e.preventDefault(); }, true); });
    document.addEventListener('selectstart', function (e) { if (!editable(e.target)) e.preventDefault(); }, true);
    document.documentElement.classList.add('ev-guard');
    document.addEventListener('dragstart', function (e) { if (e.target && /^(IMG|VIDEO|SVG|PICTURE)$/i.test(e.target.tagName)) e.preventDefault(); });
    document.addEventListener('keydown', function (e) {
      var k = (e.key || '').toLowerCase(), mod = e.ctrlKey || e.metaKey;
      if (k === 'f12' || (mod && e.shiftKey && (k === 'i' || k === 'j' || k === 'c')) || (mod && e.altKey && (k === 'i' || k === 'j' || k === 'c' || k === 'u')) || (mod && (k === 'u' || k === 's' || k === 'p'))) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  function boot() {
    document.querySelectorAll('[data-ev-delivery]').forEach(initDelivery);
    if (document.querySelector('[data-ev-delivery]')) detectCountry();
    initVideos();
    sync();
  }
  window.evInitVideos = initVideos;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
